import React from 'react';

import CLocalizedText from '../components/CLocalizedText';
import { EUserRoles } from '../enums/EUserRoles';

export const CAccountRequestRoles = {
  [EUserRoles.PROFESSIONAL_CLIENT]: {
    label: <CLocalizedText dictKey={'signUp.role.professionalClient.label'} />,
    description: <CLocalizedText dictKey={'signUp.role.professionalClient.description'} />,
    value: EUserRoles.PROFESSIONAL_CLIENT
  },
  [EUserRoles.SUITABLE_COUNTERPARTY]: {
    label: <CLocalizedText dictKey={'signUp.role.suitableCounterparty.label'} />,
    description: <CLocalizedText dictKey={'signUp.role.suitableCounterparty.description'} />,
    value: EUserRoles.SUITABLE_COUNTERPARTY
  }
} as const;
